<template>
    <div id="main-wrapper" class="section">
        <div class="container" role="main">
            <div class="flex-row row column-content-wrapper">
                <div id="content" class="col-12 article-container">
                    <article
                        id="page-150"
                        class="post-150 page type-page status-publish czr-hentry"
                    >
                        <header class="entry-header">
                            <div class="entry-header-inner">
                                <h1 class="entry-title">Privacy Policy &#038; Terms of Use</h1>
                            </div>
                        </header>
                        <div class="post-entry tc-content-inner">
                            <section class="post-content entry-content">
                                <div class="czr-wp-the-content">
                                    <p>If you choose to use our service, then you agree to the Privacy Policy and terms of use. This website and applications are provided at no cost and is intended for use as is. If you are using our Services on behalf of a business, that business accepts these terms</p>

                                    <p>Effective January 22, 2019</p>

                                    <h2>PRIVACY POLICY</h2>

                                    <p>This Privacy Policy is meant to help you understand what information we collect, why we collect it, and how we use, and disclosure of Personal Information if anyone decided to use our service.</p>

                                    <h3>Information collection and use</h3>

                                    <p>The personal information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p>

                                    <p>For a better experience, whilst using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to location. The information that we request is retained on your device, any data collected by us is anonymised to protect your identity.</p>

                                    <p>
                                        The app does use third party services that may collect information used to identify you. Please see
                                        <a
                                            href="https://policies.google.com/privacy"
                                        > Google’s privacy policy</a> for more information.
                                    </p>

                                    <h3>Log and crash data</h3>

                                    <p>
                                        Whenever you use our Service, in a case of an error in the app, we may collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as device name, operating system version, the configuration of the app when utilising our service, the time and date of your use of the service, and other statistics.
                                    </p>

                                    <h3>Cookies</h3>

                                    <p>Cookies are files with small amounts of data that is commonly used as an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your device&#8217;s internal memory.</p>

                                    <p>This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collection information and to improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this service.</p>

                                    <h3>Security</h3>

                                    <p>We value your trust in providing us with your personal information, thus we strive to use commercially acceptable means of protecting it. But remember, no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

                                    <h3>Links to Other Sites</h3>

                                    <p>This service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

                                    <h3>Children’s Privacy</h3>

                                    <p>These services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take necessary actions.</p>

                                    <h2>TERMS OF USE</h2>

                                    <h3>Using our Services</h3>

                                    <p>By using our Services, you are agreeing to these terms.</p>

                                    <p>Don’t misuse our Services. For example, don’t interfere with our Services or try to access them using a method other than the interface and the instructions that we provide.</p>

                                    <p>Using our Services does not give you ownership of any intellectual property rights in our Services or the content you access. These terms do not grant you the right to use any branding or logos used in our Services. Don’t remove, obscure, or alter any legal notices displayed in or along with our Services.</p>

                                    <p>Some of our Services are available on mobile devices. Do not use such Services in a way that distracts you and prevents you from obeying traffic or safety laws.</p>

                                    <h3>About our software</h3>

                                    <p>When a service requires or includes downloadable software, it gives you a personal, worldwide, royalty-free, non-assignable and non-exclusive license to use the software provided to you as part of the services. This license is for the sole purpose of enabling you to use and enjoy the benefit of the Services as provided by us, in the manner permitted by these terms. You may not copy, modify, distribute, sell, or lease any part of our Services or included software, nor may you reverse engineer or attempt to extract the source code of that software, unless laws prohibit those restrictions or you have our written permission.</p>

                                    <h3>Our Warranties and Disclaimers</h3>

                                    <p>We provide our Services using a commercially reasonable level of skill and care and we hope that you will enjoy using them. But there are certain things that we don’t promise about our Services. We don’t make any commitments about the content within the Services, the specific functions of the Services, or their reliability, availability, or ability to meet your needs. We provide the Services “as is”.</p>

                                    <h3>Liability for our Services</h3>

                                    <p>
                                        We will not be responsible for loss of profits, revenues, or data, financial losses or indirect, special, consequential, exemplary, or punitive damages during, or as a result of using our services or software.
                                    </p>

                                    <h2>CHANGES TO THE PRIVACY POLICY AND TERMS OF USE</h2>

                                    <p>We may update our Privacy Policy and terms of usage from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy and Terms of use via our website. These changes are effective immediately after they are posted.</p>

                                    <p>We reserve to the right to implement Ads supported for our application and website.</p>
                                </div>
                                <footer class="post-footer clearfix"></footer>
                            </section>
                            <!-- .entry-content -->
                        </div>
                        <!-- .post-entry -->
                    </article>
                </div>
            </div>
            <!-- .column-content-wrapper -->
        </div>
        <!-- .container -->

        <div id="czr-push-footer"></div>
    </div>
    <!-- #main-wrapper -->
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo () {
        return {
            title: "Privacy Policy & Terms of Use | Wersa",
            meta: [
                {name: 'robots', content: 'noindex'} 
            ]
        };
    }
};
</script>